import script from "./FormTittle.vue?vue&type=script&setup=true&lang=js"
export * from "./FormTittle.vue?vue&type=script&setup=true&lang=js"

import "./FormTittle.vue?vue&type=style&index=0&id=e459d31c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e459d31c"]])

export default __exports__